/**
 * Generated by orval v7.8.0 🍺
 * Do not edit manually.
 * Synthflow Backend
 * OpenAPI spec version: 1.0
 */

export type TransferCallActionStatus =
  (typeof TransferCallActionStatus)[keyof typeof TransferCallActionStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TransferCallActionStatus = {
  active: "active",
  paused: "paused",
} as const;
